import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { OverlayBanner } from '@/components/shared/OverlayBanner';
import { useCuboidState } from '@/components/Analysis/modules/cuboids/hooks/useCuboidState';
import { CuboidPointVisibilityControls } from '@/modules/cuboids/components/CuboidToolbar/CuboidPointVisibilityControls';
import { CuboidTransformButtonGroup } from '@/modules/cuboids/components/CuboidToolbar/CuboidTransformButtonGroup';
import { abyssColors } from '@/theme/colors';
import { Divider, Typography } from '@mui/material';

const bannerSx = {
  mb: 2,
  py: 2,
  px: 3,
  '& .MuiButtonGroup-root': {
    paddingBottom: 0,
    gap: '0.4rem',
  },
  '& .MuiIconButton-root': {
    border: 'none',
    borderRadius: '0.6rem',
    padding: '0.5rem',
    marginLeft: 0,
    color: abyssColors.primary[700],
    width: '3.2rem',
    height: '3.2rem',
    '& .MuiSvgIcon-root': {
      color: 'inherit !important',
    },
  },
  '& .MuiIconButton-root:hover': {
    backgroundColor: abyssColors.primary[100],
  },
  // Active/selected state — white icon on dark background
  '& .MuiIconButton-root[style*="background: rgb(255, 255, 255)"], & .MuiIconButton-root[style*="background: #fff"]':
    {
      backgroundColor: abyssColors.primary[700],
      '& .MuiSvgIcon-root': {
        color: '#fff !important',
      },
    },
};

export const VoiCreationControlsOverlay = () => {
  const cuboidState = useCuboidState();

  return (
    <OverlayBanner sx={bannerSx} icon={<AbyssIcon iconName="cuboid-yellow" size="lg" />}>
      <Typography variant="body1" sx={{ whiteSpace: 'nowrap' }}>
        Resize the volume to capture the required <strong>area</strong> and POIs. Click{' '}
        <strong>next</strong> to save volume size.
      </Typography>

      <Divider orientation="vertical" flexItem />
      <CuboidPointVisibilityControls cuboidState={cuboidState} />
      <Divider orientation="vertical" flexItem />
      <CuboidTransformButtonGroup cuboidState={cuboidState} />
    </OverlayBanner>
  );
};
